let pendingTasks = 0
let readyTimer = null

function canUseDocument() {
  return typeof document !== 'undefined'
}

function dispatchReady() {
  if (!canUseDocument() || pendingTasks > 0) return
  document.dispatchEvent(new Event('x-app-rendered'))
}

export function schedulePrerenderReady(delay = 600) {
  if (!canUseDocument()) return
  if (readyTimer) {
    window.clearTimeout(readyTimer)
  }
  readyTimer = window.setTimeout(dispatchReady, delay)
}

export function beginPrerenderTask() {
  if (!canUseDocument()) return () => {}
  pendingTasks += 1
  if (readyTimer) {
    window.clearTimeout(readyTimer)
    readyTimer = null
  }

  let finished = false
  return () => {
    if (finished) return
    finished = true
    pendingTasks = Math.max(0, pendingTasks - 1)
    schedulePrerenderReady()
  }
}
